import React from "react";
import { HeadingText, ParagraphText } from "../../../Libraries";
import { PoweredRupinIcon } from "../../../assets/icons/icon";
import { formatNum } from "../../../oscar-pos-core/constants";
import receiptStyles from "../UCashTransactionReceipt/styles.module.css";
import styles from "./styles.module.css";

// html2canvas mis-draws the invisible bidi isolate marks that Urdu dates carry (U+2066–2069):
// "01:28 شام" came out as "01:28شام" with broken letters. Strip them here and let dir="auto"
// on the element give the right-to-left order instead. Only affects this capture-only card.
const stripBidiMarks = (value) =>
  typeof value === "string" ? value.replace(/[\u2066-\u2069]/g, "") : value;

/**
 * Hidden receipt card rendered off-screen for html2canvas capture.
 * Usage:
 *   const receiptRef = useRef();
 *   <DownloadReceipt ref={receiptRef} {...receiptData} />
 *   // download:
 *   html2canvas(receiptRef.current, { scale: 2 }).then(canvas => { ... });
 */
const DownloadReceipt = React.forwardRef(
  (
    {
      amount = 0,
      headerText = "",
      recipientName = "",
      customerName = "",
      bankInfo = "",
      rows = [],
    },
    ref,
  ) => {
    return (
      <div className={styles.hidden}>
        <div ref={ref} className={receiptStyles.card}>
          {headerText ? (
            <div className={receiptStyles.cardHeader}>
              <ParagraphText
                className={`fontSize14 ${receiptStyles.cardHeaderText}`}
                dir="auto"
              >
                {headerText}
              </ParagraphText>
            </div>
          ) : null}

          <div className={receiptStyles.cardAmountContainer}>
            <HeadingText tag="h2" className={receiptStyles.cardAmount}>
              Rs. {formatNum(amount)}
            </HeadingText>

            {customerName ? (
              <ParagraphText className={`fontSize14 ${receiptStyles.cardRecipient}`}>
                {customerName}
              </ParagraphText>
            ) : null}

            {recipientName ? (
              <ParagraphText
                className={`fontSize14 ${receiptStyles.cardRecipient}`}
              >
                {recipientName}
              </ParagraphText>
            ) : null}

            {bankInfo ? (
              <ParagraphText className={`fontSize14 ${receiptStyles.cardBank}`}>
                {bankInfo}
              </ParagraphText>
            ) : null}
          </div>

          <div className={receiptStyles.detailsSection}>
            {rows.map((row, i) => (
              <div
                key={i}
                className={`${receiptStyles.row} ${
                  i === rows.length - 1 ? receiptStyles.rowLast : ""
                }`}
              >
                <ParagraphText
                  className={`fontSize14 ${receiptStyles.rowLabel}`}
                >
                  {stripBidiMarks(row.label)}
                </ParagraphText>
                <ParagraphText
                  className={`fontSize14 ${receiptStyles.rowValue}`}
                  dir="auto"
                >
                  {stripBidiMarks(row.value)}
                </ParagraphText>
              </div>
            ))}
          </div>

          <div className={receiptStyles.poweredBy}>
            <PoweredRupinIcon />
          </div>
        </div>
      </div>
    );
  },
);

export default DownloadReceipt;
